/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/372-pilcrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6 0h8v2h-2v14h-2V2H8v14H6V8a4 4 0 010-8z"/>'
  }
})
